export default __webpack_public_path__ + "static/media/reports.b80c4c07.jpeg";